module.exports = __webpack_public_path__ + "static/img/skyquery.4cc732e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/skyquery.png
// module id = Zoh1
// module chunks = 1